import { Box } from '@mui/material';
import { Table } from '../../../components';
import { useState } from 'react';
import React from 'react';
import { MVPFiltersProps } from '../../advanta-mvp-charts/constants';

export const MVPDataTableInternal: React.FC<
  MVPFiltersProps
> = ({
  columns,
  data: dataa,
  handlePageChange,
  pageSize,
  setPageSize,
  totalCount,
  pageNo,
  setPageNo,
  seletedIds,
  rowKey,
  stickyColumns,
  stickyColumnWidths,
}: any) => {
  const [selectedRowIds, setSelectedRowIds] = useState<
    number[]
  >([]);
  console.log(selectedRowIds, 'rows');
  const handleSelectionChange = (ids: number[]) => {
    setSelectedRowIds(ids);
  };

  return (
    <>
      <div
        style={{
          padding: 20,
          backgroundColor: '#ececec',
        }}>
        <Box>
          <Table
            columns={columns ? columns : []}
            data={dataa ? dataa : []}
            rowsPerPage={pageSize}
            setRowsPerPage={setPageSize}
            count={totalCount}
            page={pageNo}
            setPage={setPageNo}
            rowsPerPageOptions={[pageSize]}
            pageChangeHandler={handlePageChange}
            onSelectionChange={handleSelectionChange}
            stickyColumns={
              stickyColumns ? stickyColumns : [0, 1]
            }
            stickyColumnWidths={
              stickyColumnWidths
                ? stickyColumnWidths
                : [80, 160]
            }
            selectedIds={seletedIds}
            rowKey={rowKey}
          />
        </Box>
      </div>
    </>
  );
};
